import Cookies from "js-cookie/src/js.cookie"
import { Tooltip } from "~/src/lib/tooltip"
import { domReady } from "../helpers"

$(document).on("click", "a#side-nav-toggle", function (e) {
  e.preventDefault()

  let $ba = $("body.application")

  if ($ba.hasClass("nav-maximized")) {
    $ba.removeClass("nav-maximized")
    Cookies.set("_sthr_nav_exp", "off")
  } else {
    $ba.addClass("nav-maximized")
    Cookies.set("_sthr_nav_exp", "on")
  }

  toggleSideNavTooltips()
})

$(document).on("click", "#top-nav-search-toggle > a", function (e) {
  e.preventDefault()
  $("#top-nav-search").toggleClass("d-none")
  $("#top-nav-search-toggle").toggleClass("d-none")
  $("#top-nav-search").find("input")[0].focus()
})

function toggleSideNavTooltips() {
  const maximized = Cookies.get("_sthr_nav_exp") == "on"
  const method = maximized ? "uninstall" : "install"
  const elements = document.querySelectorAll("#side-nav [data-tooltip]")
  for (const element of elements) {
    Tooltip[method](element)
  }
}

domReady(() => setTimeout(toggleSideNavTooltips))
